export const REACT_URL = 'https://reactjs.org';
export const VITE_URL = 'https://vitejs.dev/guide/features.html';

export const ACTIVE_ACCOUNT_STATUS = 'Active';
export const INACTIVE_ACCOUNT_STATUS = '—';

export const DEFAULT_MODULE = 'dashboard';

// ID-12905 spike — throwaway. Where client-dashboard mounts the shared spike components.
export const SPIKE_SHARED_PORTAL_PATH = '/spike-shared-portal';

// Tightest backend cap on an Interac message: MessageForRecipient on a money request allows
// 140, Memo on an e-Transfer send rejects 140 or more.
export const INTERAC_MESSAGE_MAX_LENGTH = 139;
